export default ({
  STRING: 'string',
  SELECT: 'select',
  DATETIME: 'datetime',
  STATUS: 'status',
  BONDED: 'bonded',
  CREATEDBY: 'created_by',
  DATE: 'date',
})
